<div class="modal-center" style="display: block;">
  <div class="modal-content">
    <span class="close" (click)="onCancel()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.0005 5L5.00049 19M5.00049 5L19.0005 19" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <div class="p-30">
      <h4>Vous êtes sur le point de supprimer définitivement le rôle {{ data.role.name }}</h4>
      <p class="text-gray">Cette action est irréversible. Tous les utilisateurs et groupes ayant ce rôle le perdront.</p>

      <div class="two-columns m-t-24">
        <div class="key-value">
          <span>Nom du rôle</span>
          <p>{{ data.role.name }}</p>
        </div>
        <div class="key-value">
          <span>Type</span>
          <p>{{ getRoleType() }}</p>
        </div>
      </div>

      <div class="two-buttons">
        <button class="button neutral" (click)="onCancel()">Annuler</button>
        <button class="button danger" (click)="onConfirm()">Supprimer définitivement</button>
      </div>
    </div>
  </div>
</div>